import {
	SAVE_OPENID,

} from './mutation-types.js'
export default {
	
	saveOpenId({commit},openId){
		commit(SAVE_OPENID,openId);
	},
	
}


// WEBPACK FOOTER //
// ./src/store/action.js